import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=1a4d61ca&scoped=true&"
import script from "./Franchise.vue?vue&type=script&lang=js&"
export * from "./Franchise.vue?vue&type=script&lang=js&"
import style0 from "./Franchise.vue?vue&type=style&index=0&id=1a4d61ca&scoped=true&lang=css&"
import style1 from "./Franchise.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d61ca",
  null
  
)

export default component.exports